import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { TreeNode } from 'src/app/orgChart/common/treenode';
import {
  LoadService,
  SiteService,
  UtilitiesService
} from 'src/app/services/index';
import { Constants } from 'src/app/shared/index';
export interface ExpandNode {
  id: string;
  parent: TreeNode;
  child: TreeNode;
}
@Component({
  selector: 'app-load-on-tree',
  templateUrl: './load-on-tree.component.html',
  styleUrls: ['./load-on-tree.component.scss']
})
export class LoadOnTreeComponent implements OnInit, OnDestroy {
  private nodesList = new Map();
  private nodeChilds = new Map();
  private nodeLevel1List = new Map();
  nodeLevel = 1;
  siteId: string;
  apiData: any;
  // Load ON Tree View
  loadONTreeNodesStatus = [];
  meterIdsForLoadONTree = [];
  metersForLoadONTree = [];
  // Meter View
  meterViewInterval = 60 * 2;
  intervalForLoadONTree = undefined;
  subscription: Subscription;
  loadOnTreeLastF5Timestamp = undefined;
  selectedNode: TreeNode;
  loadONTreeData: TreeNode[];

  tmpCount = 0;
  maxLevel = 0;
  tmpNode: any;
  foundNode: any;
  expandNodes: ExpandNode[];
  currToggleNode: TreeNode;
  nId = 0;
  interval: any;
  constructor(
    private activeRoute: ActivatedRoute,
    private siteService: SiteService,
    private utilitiesService: UtilitiesService,
    private loadService: LoadService
  ) {
    this.loadONTreeData = [];
    this.nodesList = new Map();
    this.siteId = this.activeRoute.snapshot.queryParams['siteId']; // 'JAPBOSCH30201064';
  }

  ngOnInit() {
    this.getTreeConfiguration(this.siteId);
    this.interval = setInterval(() => {
      console.log('Refresh');
      this.loadONTreeNodesStatus = [];
      this.getMetersStatus(false);
    }, 60000);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    clearInterval(this.interval);
  }
  onNodeSelect(event) {}

  onNodetoggle(event) {
    const t = this;
    if (event.node.verticalBranchLevel > 0) {
      t.currToggleNode = event.node;
      t.foundNode = null;
      t.relocationVerticalParentNode(t.loadONTreeData[0], t.currToggleNode);
    }
  }
  forceCollapseChild(parent, nodes) {
    const t = this;
    nodes.forEach(function (n) {
      if (n.expanded) {
        const tmp: ExpandNode = {
          id: parent.nId + n.nId,
          parent: parent,
          child: n
        };
        const index = t.expandNodes.findIndex((v) => v.id === tmp.id);
        if (index >= 0) {
          t.expandNodes.splice(index, 1);
        }
        n.expanded = false;
      }
    });
  }
  findParentNode(data, node) {
    const t = this;
    let found = null;
    return new Promise((resolve, reject) => {
      if (data.children && data.children.length) {
        found = data.children.find((n) => n.nId === node.nId);
        if (found) {
          t.foundNode = data;
        } else {
          data.children.forEach(function (n) {
            t.findParentNode(n, node);
          });
        }
      }
      resolve(t.foundNode);
    });
  }

  relocationVerticalParentNode(data, node) {
    const t = this;

    const promise = t.findParentNode(data, node);
    promise.then((val) => {
      const found: TreeNode = val;
      if (found && found.showInVertical) {
        t.ProcessExpandNode(found, t.currToggleNode);
        if (t.currToggleNode.children && t.currToggleNode.children.length) {
          t.forceCollapseChild(found, t.currToggleNode.children);
        }
        t.CalculateExpandNode(found, t.currToggleNode);
      } else {
        node = found;
        if (found.verticalBranchLevel > 0) {
          t.relocationVerticalParentNode(data, found);
        }
      }
    });
  }
  ProcessExpandNode(parent, child) {
    const t = this;
    if (!t.expandNodes || t.expandNodes.length <= 0) {
      t.expandNodes = [];
    }

    const tmp: ExpandNode = {
      id: parent.nId + child.nId,
      parent: parent,
      child: child
    };
    if (child.expanded) {
      t.expandNodes.push(tmp);
    } else {
      const index = t.expandNodes.findIndex((n) => n.id === tmp.id);
      if (index >= 0) {
        t.expandNodes.splice(index, 1);
      }
    }
  }

  CalculateExpandNode(parent, child) {
    const t = this;
    if (!child.expanded) {
      const branchNodes = t.expandNodes.filter(
        (n) => n.parent.nId === parent.nId
      );
      const found = branchNodes.filter(
        (n) => n.child.verticalBranchLevel >= child.verticalBranchLevel
      );
      if (!found || found.length === 0) {
        parent.marginLeft =
          child.verticalBranchLevel - 1 > 0
            ? (child.verticalBranchLevel - 1) * 11
            : 1;
      }
      // if (found.length > 0) {
      //   parent.marginLeft = child.verticalBranchLevel * 11;
      // }
    } else {
      parent.marginLeft = child.verticalBranchLevel * 11;
    }
  }

  getTreeConfiguration(siteId: string) {
    const t = this;

    this.siteService
      .getTreeConfiguration(siteId, ['loadONTreeData'])
      .subscribe((data) => {
        if (data.loadONTreeData !== undefined) {
          t.apiData = JSON.parse(data.loadONTreeData);

          const promise = t.parseTreeData(t.apiData[0], null, this.nodeLevel);
          promise
            .then((val) => {
              t.setChildLevelForTree(t.loadONTreeData[0]);
              // let loadRIds = [];
              // for (let i = 0; i < t.loadONTreeData.length; i++) {
              //   t.getLoadRIdsFromNode(t.loadONTreeData[i].data, loadRIds);
              // }
              // loadRIds = t.utilitiesService.uniqueArray(loadRIds);

              let loadIds = [];
              for (let i = 0; i < t.loadONTreeData.length; i++) {
                t.getLoadIdsFromNode(t.loadONTreeData[i].data, loadIds);
              }
              loadIds = t.utilitiesService.uniqueArray(loadIds);
              t.meterIdsForLoadONTree = [];
              // t.loadService.getMetersOfLoads({ loadRIds }).subscribe(meters => {
              t.loadService
                .getMetersFromLoadIds({ loadIds, siteId })
                .subscribe((meters) => {
                  t.metersForLoadONTree = meters;
                  for (let i = 0; i < meters.length; i++) {
                    t.meterIdsForLoadONTree.push(meters[i].meterId);
                  }
                  // t.getMetersStatus(false);

                  t.intervalForLoadONTree = timer(
                    0,
                    t.meterViewInterval * 1000
                  );
                  this.subscription = t.intervalForLoadONTree.subscribe(() => {
                    // console.log('getMetersStatus-time:' + moment().toString());
                    t.getMetersStatus(false);
                  });
                });
            })
            .catch((val) => console.log(val));
        }
      });
  }

  parseTreeData(root, parent, nodeLevel: number) {
    return new Promise((resolve, reject) => {
      const t = this;
      const item: TreeNode = {};

      item.label = root.title;
      item.data = root;
      item.expanded = false;
      if (
        root != null &&
        root.showInVertical != null &&
        root.showInVertical === true &&
        root.verticalBranchLevel >= 1
      ) {
        root.showInVertical = false;
      }
      item.showInVertical =
        root.showInVertical != null ? root.showInVertical : false;
      item.verticalBranchLevel =
        root.verticalBranchLevel != null ? root.verticalBranchLevel : 0;
      item.type = 'person';
      item.styleClass = 'ui-person';
      if (parent === null) {
        item.expanded = true;
        item.level = 1;
        t.nId = 1;
        item.nId = t.nId;
        t.loadONTreeData.push(item);
        if (root.nodes != null && root.nodes.length > 0) {
          root.nodes.forEach(function (n) {
            // t.nodeLevel1List.set(n.id, 2);
            t.nodeLevel1List.set(n.title, 2);
          });
        }
      } else {
        const number = t.nodeLevel1List.get(item.data.title);

        item.level = number ? number : null;

        if (parent.children === undefined || parent.children.length <= 0) {
          parent.children = [];
        }
        item.nId = ++t.nId;
        parent.children.push(item);
      }

      if (root.nodes != null && root.nodes.length > 0) {
        item.children = [];
        t.nodeLevel = t.nodeLevel + 1;
        root.nodes.forEach(function (n) {
          t.nodesList.set(n.id, t.nodeLevel);
        });
        const nodes = root.nodes;

        if (
          root != null &&
          root.showInVertical != null &&
          root.showInVertical === true &&
          root.verticalBranchLevel === undefined
        ) {
          this.tmpNode = root;
          this.tmpCount = 1;
          t.nodeChilds.set(root.id, 1);
          for (const iterator of nodes) {
            iterator.verticalBranchLevel = 1;
          }
        } else if (root != null && root.verticalBranchLevel >= 1) {
          for (const iterator of nodes) {
            const level = root.verticalBranchLevel + 1;
            this.tmpCount = level;
            iterator.verticalBranchLevel = level;
            if (this.tmpCount > t.nodeChilds.get(this.tmpNode.id)) {
              t.nodeChilds.set(this.tmpNode.id, root.verticalBranchLevel + 1);
            }
          }
        }
        for (const iterator of nodes) {
          this.parseTreeData(iterator, item, t.nodeLevel);
        }
      }
      resolve(true);
    });
  }
  setChildLevelForTree(root) {
    const t = this;
    if (root.showInVertical === true) {
      root.childLevelCount = this.nodeChilds.get(root.data.id);
      // console.log("Id: "+root.data.id+" Item: " + root.label + " --Level: " + root.level+ " --childLevelCount: " + root.childLevelCount);
    }

    if (root.children != null && root.children.length > 0) {
      const nodes = root.children;
      for (const iterator of nodes) {
        t.setChildLevelForTree(iterator);
      }
    }
  }

  getLoadRIdsFromNode(node, loadRIds) {
    const t = this;
    if (node.loadRId !== undefined) {
      loadRIds.push(node.loadRId);
    }
    for (let i = 0; i < node.nodes.length; i++) {
      t.getLoadRIdsFromNode(node.nodes[i], loadRIds);
    }
  }

  getLoadIdsFromNode(node, loadIds) {
    const t = this;
    if (node.loadId !== undefined) {
      loadIds.push(node.loadId);
    }
    if (node.nodes !== undefined) {
      for (let i = 0; i < node.nodes.length; i++) {
        t.getLoadIdsFromNode(node.nodes[i], loadIds);
      }
    }
  }

  getMetersStatus(hideLoading) {
    const t = this;
    let model = {};
    if (t.meterIdsForLoadONTree) {
      model = { siteId: t.siteId, meterIds: t.meterIdsForLoadONTree };
      t.loadService
        .getMetersStatus(model, hideLoading)
        .subscribe((metersStatusData) => {
          for (let i = 0; i < t.metersForLoadONTree.length; i++) {
            t.loadONTreeNodesStatus.push({
              rId: t.metersForLoadONTree[i].meterId,
              status: metersStatusData[t.metersForLoadONTree[i].meterId]
            });
            t.loadOnTreeLastF5Timestamp = new Date();
          }
        });
    }
  }

  getNodeClass(node) {
    const classON = Constants.MACHINE.Label_Machine_ON;
    const classOFF = Constants.MACHINE.Label_Machine_OFF;
    const classNA = Constants.MACHINE.Label_Data_NA;
    const nodeStatus = this.getNodeStatus(node);
    const nodeClass =
      nodeStatus === Constants.SENSOR_HEALTH.ON
        ? classON
        : nodeStatus === Constants.SENSOR_HEALTH.OFF
        ? classOFF
        : classNA;
    return nodeClass;
  }

  getNodeStatus = function (node) {
    let nodeStatus = Constants.SENSOR_HEALTH.NA;
    if (node.nodes === undefined || (node.nodes && node.nodes.length === 0)) {
      if (
        node.nodeType === Constants.NODE_TYPE.LOAD ||
        node.loadRId !== undefined
      ) {
        nodeStatus = this.getLoadStatus(node.meterId);
      }
    } else {
      for (let i = 0; i < node.nodes.length; i++) {
        const childStatus = this.getNodeStatus(node.nodes[i]);
        if (childStatus === Constants.SENSOR_HEALTH.ON) {
          nodeStatus = Constants.SENSOR_HEALTH.ON;
          break;
        } else if (childStatus === Constants.SENSOR_HEALTH.OFF) {
          nodeStatus = Constants.SENSOR_HEALTH.OFF;
        }
      }
    }
    return nodeStatus;
  };

  getLoadStatus(loadRId) {
    let status = Constants.SENSOR_HEALTH.NA;
    for (let i = 0; i < this.loadONTreeNodesStatus.length; i++) {
      if (this.loadONTreeNodesStatus[i].rId === loadRId) {
        status = this.loadONTreeNodesStatus[i].status;
        break;
      }
    }
    return status;
  }
}
